module.exports = __webpack_public_path__ + "h5/img/close.b8f66371.gif";